import { Schema } from 'normalizr'

const listing = new Schema('listing', { idAttribute: 'ml' })

export default listing
